/*--------------------------------------------------------------
# Modal page-canvas
--------------------------------------------------------------*/
const modal = document.getElementById('page-canvas');
if (modal != null)
{
    let modalOpen = false;

    // Open the Modal
    function showModal(el)
    {
        document.querySelector(el).classList.add("visible");
        modalOpen = true;
    }

    const triggerModalReset = document.querySelector('[data-toggle="modal-reset"]');
    triggerModalReset.addEventListener('click', (ev) =>
    {
        ev.stopPropagation();
        showModal("#modal-reset");
    });

    const triggerModalReturn = document.querySelector('[data-toggle="modal-return"]');
    triggerModalReturn.addEventListener('click', (ev) =>
    {
        ev.stopPropagation();
        showModal("#modal-return");
    });


    window.addEventListener('show-thematique-intro-modal', () => {
        showModal('#modal-collage-intro');
    })

    // Hide the Modal
    function hideModal()
    {
        let dismissModal = document.querySelectorAll('[data-modal="modal"]');
        dismissModal.forEach(elem =>
                             {
                                 elem.classList.remove("visible");
                             });

        //document.querySelector('#btn-return').focus();
        modalOpen = false;
    }

    const dismissModal = document.querySelectorAll('[data-dismiss="modal"]');
    dismissModal.forEach(elem => elem.addEventListener('click', (ev) =>
    {
        ev.stopPropagation();

        hideModal();
    }));

    document.onkeydown = function (evt)
    {
        if (modalOpen)
        {
            evt = evt || window.event;
            if (evt.key == "Escape")
            {
                hideModal();
            }
        }
    };

    const resetBtn = document.getElementById('reset-collage');
    resetBtn.addEventListener('click', () =>
    {
        window.collage.reset();
        hideModal();
    });
}
